import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from '@material-ui/core/IconButton';
import { DeleteOutline } from '@material-ui/icons';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import { FDDeleteButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import ListItemRemoveDialog
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/ListItemRemoveButton/ListItemRemoveDialog';

const styles = theme => ({
  root: {},
  deleteButton: {
    margin: 'auto',
    backgroundColor: theme.palette.facet.accentBlue21,
  },
});

const ListItemRemoveButton = ({
  className,
  classes,
  resource,
  dialogProps,
  onDelete,
  stopPropagation,
  useFDButton,
  test,
  ...rest
}) => {
  const onRemove = async (e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    onDelete(resource, e);
  };

  const onClose = async (e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  const onOpen = async (e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  const {
    dialogOpen,
    loading,
    handleClose,
    handleSubmit,
    handleOpen,
  } = useConfirmationDialogState({
    onClose,
    onSubmit: onRemove,
    onOpen,
  });

  const canDelete = resource.meta().canDelete();
  if (!canDelete) return null;

  return (
    <div className={classNames(classes.root, className)}>
      { useFDButton
        ? (
          <FDDeleteButton
            appearance={'secondary'}
            onClick={handleOpen}
            {...dataAttrs(test)}
          />)
        : (
          <IconButton
            className={classes.deleteButton}
            onClick={handleOpen}
            size="small"
            test={test}
            {...rest}
          >
            <DeleteOutline color="primary" />
          </IconButton>
        )
      }
      <ListItemRemoveDialog
        dialogOpen={dialogOpen}
        loading={loading}
        dialogProps={dialogProps}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

ListItemRemoveButton.defaultProps = {
  className: '',
  dialogProps: {},
  stopPropagation: false,
  useFDButton: false,
  test: '',
};

ListItemRemoveButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  dialogProps: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  stopPropagation: PropTypes.bool,
  useFDButton: PropTypes.bool,
  test: PropTypes.string,
};

export default withStyles(styles)(ListItemRemoveButton);
